import { render } from "./MediaCardCore.vue?vue&type=template&id=e021fe3c&ts=true"
import script from "./MediaCardCore.vue?vue&type=script&lang=ts"
export * from "./MediaCardCore.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__